import Repository from "@shared/services/api/abstracts/Repository";
import { AxiosRequestConfig } from "axios";
import { PublicBasedTTSeatPermissionsRenewalPermissionsSerializer } from "../types/seating-types";

export default class PublicBasedTTSeatPermissionsRenewalPermissionsRepository extends Repository<PublicBasedTTSeatPermissionsRenewalPermissionsSerializer> {
  public readonly repositoryName =
    "PublicBasedTTSeatPermissionsRenewalPermissionsRepository";

  public readonly endpoint =
    "/api/public/events/ticket-types/seat-permissions/renewal-permissions/";

  public async getPermissions(config: AxiosRequestConfig) {
    const { data } = await this.request(this.buildUrl(), config);
    return data;
  }
}
